import React from 'react';
import { Calendar } from 'lucide-react';

export default function FloatingConsultation() {
  return (
    <a
      href="https://www.mjrassociates.eu/contact"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-consultation-btn"
      className="fixed right-0 top-1/2 -translate-y-1/2 z-50 group"
    >
      <div className="flex items-center gap-2 bg-[#0D1B2A] text-white pl-4 pr-3 py-3 rounded-l-xl shadow-2xl border border-r-0 border-white/10 transition-all duration-300 translate-x-[calc(100%-44px)] hover:translate-x-0">
        <Calendar size={18} className="text-[#D4A853] flex-shrink-0" />
        <span className="text-sm font-semibold whitespace-nowrap">Book a Free Consultation</span>
        <span className="text-[10px] text-[#D4A853]/80 ml-1 whitespace-nowrap">MJR Associates</span>
      </div>
    </a>
  );
}
